<template>
  <div style="max-width: 1200px">
    
    <h3>装备列表 <span style="font-size:12px">（版本: {{ dragontail.version }}）</span></h3>

    <table class="ui celled table striped black center aligned">
      <tr style="height: 68px; font-weight: bold">
        <td style="width: 100px">LOGO</td>
        <td style="width: 160px">装备名称</td>
        <td style="width: 100px">ID</td>
        <td style="width: 500px; text-align: left">装备描述</td>
      </tr>
      <tr v-for="item in items" :key="item.id" style="height: 68px">
        <td>
          <img :src="dragontail.generate_item_logo_url(item.id)" style="width: 40px; height: 40px" />
        </td>
        <td>{{ item.name }}</td>
        <td>{{ item.id }}</td>
        <td v-html="item.description" style="text-align: left"></td>
      </tr>
    </table>

  </div>
</template>

<script>

  import lodash from "lodash"
  import dragontail from "@/utils/dragontail.js"

  export default {
    data: function(){
      return {
        items: []
      }
    },
    mounted: function(){
      this.init()
    },
    computed: {
      dragontail: function(){
        return dragontail
      },
      lodash: function(){
        return lodash
      }
    },
    methods: {
      init: async function(){

        var thisApp = this

        var newItems = await dragontail.async_get_or_fetch_items()

        thisApp.items = newItems
      }
    }
  }

</script>

